export const CREDENTIAL_BEARING_TYPES = ["s3"];
